"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _Table = _interopRequireDefault(require("../table/Table"));

var _Paginator = _interopRequireDefault(require("../paginator/Paginator"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _Icons = _interopRequireDefault(require("./Icons"));

var _utils = require("../common/utils.js");

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var normalizeSortValue = function normalizeSortValue(sortValue) {
  return typeof sortValue === "string" ? sortValue.toUpperCase() : sortValue;
};

var sortArray = function sortArray(index, order, resultset) {
  return resultset.slice().sort(function (element1, element2) {
    var sortValueA = normalizeSortValue(element1[index].sortValue || element1[index].displayValue);
    var sortValueB = normalizeSortValue(element2[index].sortValue || element2[index].displayValue);
    var comparison = 0;

    if ((0, _typeof2["default"])(sortValueA) === "object") {
      comparison = -1;
    } else if ((0, _typeof2["default"])(sortValueB) === "object") {
      comparison = 1;
    } else if (sortValueA > sortValueB) {
      comparison = 1;
    } else if (sortValueA < sortValueB) {
      comparison = -1;
    }

    return order === "descending" ? comparison * -1 : comparison;
  });
};

var getMinItemsPerPageIndex = function getMinItemsPerPageIndex(currentPageInternal, itemsPerPage, page) {
  return currentPageInternal === 1 ? 0 : itemsPerPage * (page - 1);
};

var getMaxItemsPerPageIndex = function getMaxItemsPerPageIndex(minItemsPerPageIndex, itemsPerPage, resultset, page) {
  return minItemsPerPageIndex + itemsPerPage > resultset.length ? resultset.length : itemsPerPage * page - 1;
};

var DxcResultsetTable = function DxcResultsetTable(_ref) {
  var columns = _ref.columns,
      rows = _ref.rows,
      _ref$showGoToPage = _ref.showGoToPage,
      showGoToPage = _ref$showGoToPage === void 0 ? true : _ref$showGoToPage,
      _ref$itemsPerPage = _ref.itemsPerPage,
      itemsPerPage = _ref$itemsPerPage === void 0 ? 5 : _ref$itemsPerPage,
      itemsPerPageOptions = _ref.itemsPerPageOptions,
      itemsPerPageFunction = _ref.itemsPerPageFunction,
      margin = _ref.margin,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var colorsTheme = (0, _useTheme["default"])();

  var _useState = (0, _react.useState)(1),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      page = _useState2[0],
      changePage = _useState2[1];

  var _useState3 = (0, _react.useState)(-1),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      sortColumnIndex = _useState4[0],
      changeSortColumnIndex = _useState4[1];

  var _useState5 = (0, _react.useState)("ascending"),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      sortOrder = _useState6[0],
      changeSortOrder = _useState6[1];

  var minItemsPerPageIndex = (0, _react.useMemo)(function () {
    return getMinItemsPerPageIndex(page, itemsPerPage, page);
  }, [itemsPerPage, page]);
  var maxItemsPerPageIndex = (0, _react.useMemo)(function () {
    return getMaxItemsPerPageIndex(minItemsPerPageIndex, itemsPerPage, rows, page);
  }, [itemsPerPage, minItemsPerPageIndex, page, rows]);
  var sortedResultset = (0, _react.useMemo)(function () {
    return sortColumnIndex !== -1 ? sortArray(sortColumnIndex, sortOrder, rows) : rows;
  }, [sortColumnIndex, sortOrder, rows]);
  var filteredResultset = (0, _react.useMemo)(function () {
    return sortedResultset && sortedResultset.slice(minItemsPerPageIndex, maxItemsPerPageIndex + 1);
  }, [sortedResultset, minItemsPerPageIndex, maxItemsPerPageIndex]);

  var goToPage = function goToPage(newPage) {
    changePage(newPage);
  };

  var changeSorting = function changeSorting(columnIndex) {
    changePage(1);
    changeSortColumnIndex(columnIndex);
    changeSortOrder(sortColumnIndex === -1 || sortColumnIndex !== columnIndex ? "ascending" : sortOrder === "ascending" ? "descending" : "ascending");
  };

  (0, _react.useEffect)(function () {
    rows.length > 0 ? changePage(1) : changePage(0);
  }, [rows]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.table
  }, /*#__PURE__*/_react["default"].createElement(DxcResultsetTableContainer, {
    margin: margin
  }, /*#__PURE__*/_react["default"].createElement(_Table["default"], null, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, columns.map(function (column, index) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: "tableHeader_".concat(index),
      "aria-sort": column.isSortable ? sortColumnIndex === index ? sortOrder : "none" : undefined
    }, /*#__PURE__*/_react["default"].createElement(HeaderContainer, {
      role: column.isSortable ? "button" : undefined,
      key: "headerContainer_".concat(index),
      onClick: function onClick() {
        column.isSortable && changeSorting(index);
      },
      tabIndex: column.isSortable ? tabIndex : -1,
      isSortable: column.isSortable
    }, /*#__PURE__*/_react["default"].createElement("span", null, column.displayValue), column.isSortable && /*#__PURE__*/_react["default"].createElement(SortIcon, null, sortColumnIndex === index ? sortOrder === "ascending" ? _Icons["default"].arrowUp : _Icons["default"].arrowDown : _Icons["default"].bothArrows)));
  }))), /*#__PURE__*/_react["default"].createElement("tbody", null, filteredResultset.map(function (cells, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: "resultSetTableCell_".concat(index)
    }, cells.map(function (cellContent, index) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: "resultSetTableCellContent_".concat(index)
      }, cellContent.displayValue);
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_Paginator["default"], {
    totalItems: rows.length,
    itemsPerPage: itemsPerPage,
    itemsPerPageOptions: itemsPerPageOptions,
    itemsPerPageFunction: itemsPerPageFunction,
    currentPage: page,
    showGoToPage: showGoToPage,
    onPageChange: goToPage,
    tabIndex: tabIndex
  })));
};

var calculateWidth = function calculateWidth(margin) {
  return "calc(100% - ".concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")");
};

var DxcResultsetTableContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return calculateWidth(props.margin);
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var HeaderContainer = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  gap: 8px;\n  width: fit-content;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  padding: 3px;\n  cursor: ", ";\n\n  ", "\n"])), function (props) {
  return props.theme.headerTextAlign === "center" ? "center" : props.theme.headerTextAlign === "right" ? "flex-end" : "flex-start";
}, function (props) {
  return props.isSortable ? "pointer" : "default";
}, function (props) {
  return props.isSortable && "&:focus {\n      outline: #0095ff solid 2px;\n    }";
});

var SortIcon = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  height: 14px;\n  width: 14px;\n  color: ", ";\n\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"])), function (props) {
  return props.theme.sortIconColor;
});

var _default = DxcResultsetTable;
exports["default"] = _default;